<div class="wm-form"
    *ngIf="liveWidgetSettingsService.selectedComponent && liveWidgetSettingsService.selectedPropertyGroup.name === 'basic' && liveWidgetSettingsService.activeTab.type === 'actions'"
    [ngClass]='{"disabled" : !liveWidgetSettingsService.selectedComponent.button.include}'>
    <div *ngIf="selectedcomponent && liveWidgetSettingsService.selectedComponent && !liveWidgetSettingsService.componentDefnObject.isLayout" class="dialog-form-section">
        <p class="alert app-message alert-info"
            *ngIf="liveWidgetSettingsService.showActionMessage || liveWidgetSettingsService._showDeviceActionMessage"><i
                class="icon wms wms-info"></i>
            <span
                *ngIf="liveWidgetSettingsService._showDeviceActionMessage">{{locale.MESSAGE_DEVICE_ACTION_BUTTON_INFO}}</span>
            <span *ngIf="liveWidgetSettingsService.showActionMessage">{{locale.MESSAGE_CUSTOM_SCRIPT_CREATED}}<a
                    style='cursor:pointer' (click)='liveWidgetSettingsService.saveDesignerSettings(true)'>
                    {{locale.LABEL_CLICK_HERE_TO_EDIT}}</a></span>
        </p>
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET}}</label>
            <select class="form-control app-select"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.widgetType"
                (ngModelChange)="liveWidgetSettingsService.onActionWidgetChange(liveWidgetSettingsService.selectedComponent.button, 'btn-secondary')" data-identifier="property-widget">
                <option value="" [ngValue]="undefined" selected >{{locale.LABEL_WIDGET_DESIGNER_SELECT_A_WIDGET}}</option>
                <option *ngFor="let value of liveWidgetSettingsService.actionWidgets">
                    {{value}}
                </option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TABLE_WIDGET}}" class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_CAPTION}}</label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.displayName"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.displayName?.indexOf('bind:') !== 0"
                   (ngModelChange)="onSelectedCompChange('button', 'displayName', $event)"
                   [ngModelOptions]="{ updateOn: 'blur' }"
                placeholder="{{locale.PLACEHOLDER_DESIGNER_BUTTON_CAPTION}}" data-identifier="property-caption" />
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.displayName?.indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    value="{{liveWidgetSettingsService.selectedComponent.button.displayName}}" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.displayName"
                    title="{{liveWidgetSettingsService.selectedComponent.button.displayName}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'displayName')"></button>
            </div>
            <button name="wm-bind-property-caption"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'displayName', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_CAPTION}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.title"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.title?.indexOf('bind:') !== 0"
                placeholder="{{locale.PLACEHOLDER_DESIGNER_BUTTON_TITLE}}" data-identifier="property-title"/>
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.title?.indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.title" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.title"
                    title="{{liveWidgetSettingsService.selectedComponent.button.title}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'title')"></button>
            </div>
            <button name="wm-bind-property-title"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'title', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TITLE}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_CLASS}}</label>
            <input class="form-control app-textbox"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.class?.indexOf('bind:') !== 0"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.class"
                placeholder="{{locale.PLACEHOLDER_DESIGNER_BUTTON_CLASS}}" data-identifier="property-class" />
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.class?.indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.class" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.class"
                    title="{{liveWidgetSettingsService.selectedComponent.button.class}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'class')"></button>
            </div>
            <button name="wm-bind-property-class"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'class', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>        
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_CLASS}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.designerType === 'TABLE'">
            <label
                class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS}}</label>
            <div class="conditional-classes-container">
                <div
                    *ngFor="let cls of liveWidgetSettingsService.selectedComponent.button.ngClasses; first as $first; last as $last">
                    <!-- TODO: ng-model-options="{debounce:300} -->
                    <input type="text" [(ngModel)]="cls.className"
                        class="form-control app-textbox conditional-classname" [ngClass]="{'error': cls?.error?.class}"
                        placeholder="{{locale.LABEL_CLASS_NAME}}"
                        (ngModelChange)="validateAndUpdateExpression.emit(cls);" data-identifier="property-conditionalclass" />
                    <input type="text" [(ngModel)]="cls.condition" ng-model-options="{debounce:300}"
                        [ngClass]="{'error': cls?.error?.condition}"
                        class="form-control app-textbox conditional-expression"
                        placeholder="{{locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION}}"
                        (ngModelChange)="validateAndUpdateExpression.emit(cls);" data-identifier="property-conditionalexpression"/>
                    <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_REMOVE_CONDITION}}"
                        class="btn btn-secondary conditional-class-remove-btn"
                        (click)="liveWidgetSettingsService.removeConditionalClass('actionWidget', cls)">
                        <i class="wm-icon wms wms-delete"></i>
                    </button>
                    <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_ADD_CONDITIONAL_CLASS}}"
                        class="btn btn-secondary conditional-class-add-btn" *ngIf="$last"
                        (click)="liveWidgetSettingsService.addConditionalClass(cls, liveWidgetSettingsService.selectedComponent.button)">
                        <i class="wm-icon wms wms-plus"></i>
                    </button>
                    <i placement="right" [tooltipAppendToBody]="true"
                        tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS}}"
                        class="wm-icon wms wms-help" *ngIf="$first"></i>
                    <p class="row help-block error" *ngIf="cls?.errorMsg">{{cls.errorMsg}}</p>
                </div>
            </div>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.designerType === 'TABLE'">
          <label
                class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE}}</label>
            <div class="property-value bind-input-wrapper"
                *ngIf="(liveWidgetSettingsService.selectedComponent.button?.conditionalstyle?.toString().indexOf('bind:') === 0)">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    [value]="liveWidgetSettingsService.selectedComponent.button.conditionalstyle" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.conditionalstyle"
                    title="{{liveWidgetSettingsService.selectedComponent.button.conditionalstyle}}" data-identifier="property-conditionalstyle" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent?.button, 'conditionalstyle')"></button>
            </div>
            <button name="wm-bind-property-conditionalstyle"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'conditionalstyle', 'button', '', 'expression')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE}}" class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_ICONCLASS}}</label>
            <div class="select-icon-class input-group">
                <span class="input-group-addon"
                    (click)="liveWidgetSettingsService.openIconChooserDialog(liveWidgetSettingsService.selectedComponent.button)">
                    <i
                        [ngClass]="liveWidgetSettingsService.selectedComponent.button?.iconclass || 'wms wms-search'"></i>
                </span>
                <input class="form-control app-textbox"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.iconclass"
                    placeholder="{{locale.PLACEHOLDER_DESIGNER_BUTTON_ICON_CLASS}}" data-identifier="property-iconclass" />
            </div>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_ICONCLASS}}" class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_ACTION}}</label>
            <div class="col-sm-7 event-input-column">
                <wms-event-handler class="event-handler-parent"
                    [eventExpr]="liveWidgetSettingsService.selectedComponent.button.action" eventName="Action"
                    (onChange)="liveWidgetSettingsService.onEventChange(liveWidgetSettingsService.selectedComponent.button, $event)"
                    (onNavigateAction)="liveWidgetSettingsService.saveDesignerSettings(true, $event)"
                    [eventOptions] = "liveWidgetSettingsService.eventOptions" data-identifier="property-action"></wms-event-handler>
            </div>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{(liveWidgetSettingsService.designerType === 'LIVEFORM') ? locale.HELP_MESSAGE_WIDGET_DESIGNER_LIVE_FORM_ACTIONS : locale.HELP_MESSAGE_WIDGET_DESIGNER_ACTION}}"
                class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.selectedComponent.button.widgetType === 'anchor'">
            <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_HYPERLINK}}</label>
            <input class="form-control app-textbox"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.hyperlink?.indexOf('bind:') !== 0"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.hyperlink"
                placeholder="{{locale.PLACEHOLDER_HYPERLINK}}" data-identifier="property-hyperlink" />
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.hyperlink?.indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    value="{{liveWidgetSettingsService.selectedComponent.button.hyperlink}}" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.hyperlink"
                    title="{{liveWidgetSettingsService.selectedComponent.button.hyperlink}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'hyperlink')"></button>
            </div>
            <button name="wm-bind-property-hyperlink"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'hyperlink', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_HYPERLINK}}"
                class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.selectedComponent.button.widgetType === 'anchor'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_TARGET}}</label>
            <div class="form-control wms-typeahead-live-filter">
                <wms-typeahead name="wms-binding-column"
                    [model]="liveWidgetSettingsService.selectedComponent.button.target"
                    [options]="liveWidgetSettingsService.targetsList" (onSelect)="onSelectedCompChange('button', 'target', $event.value)" data-identifier="property-target"> </wms-typeahead>
            </div>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_TARGET}}"
                class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.designerType === 'LIVEFORM' || liveWidgetSettingsService.designerType === 'FORM'">
            <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_TYPE}}</label>
            <select [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.type"
                class="form-control app-select" data-identifier="property-type">
                <option value="">{{locale.LABEL_WIDGET_DESIGNER_TYPE_OF_FIELD}}</option>
                <option *ngFor="let item of liveWidgetSettingsService.buttonTypes | keyvalue" value="{{item.value}}">
                    {{item.value}}
                </option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale['MESSAGE_HELP_PROPERTY_WM-BUTTON_TYPE']}}" class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.selectedComponent.button.hasOwnProperty('position') && !(liveWidgetSettingsService.activeWidgetScope.isLayoutDialog || liveWidgetSettingsService.activeWidgetScope.formlayout === 'page')">
            <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_GRIDACTIONSPOSITION}}</label>
            <wm-checkboxset [datavalue]="liveWidgetSettingsService.selectedComponent.button.position"
                [dataset]="liveWidgetSettingsService.actionspositions" datafield="value"
                displayfield="label" (onChange)="handlePositionChange($event.value)"></wm-checkboxset>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.MESSAGE_HELP_PROPERTY_GRIDACTIONSPOSITION}}" class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_SHOW}}</label>
            <wms-toggle id="toggle-show" [hideLabels]="true"
                *ngIf="liveWidgetSettingsService.selectedComponent.button.show?.toString().indexOf('bind:') !== 0"
                [onValue]="true" [offValue]="false"
                [model]="liveWidgetSettingsService.selectedComponent.button.show"
                        (onChange)="onSelectedCompChange('button', 'show', $event)"></wms-toggle>
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button.show?.toString().indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    value="{{liveWidgetSettingsService.selectedComponent.button.show}}" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.show"
                    title="{{liveWidgetSettingsService.selectedComponent.button.show}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'show', 'true')"></button>
            </div>
            <button name="wm-bind-property-show"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'show', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SHOW}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.selectedComponent.button?.widgetType !== 'anchor'">
            <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_DISABLED}}</label>
          <wms-toggle id="toggle-disabled" [hideLabels]="true"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.disabled?.toString().indexOf('bind:') !== 0"
                        [onValue]="true" [offValue]="false"
                        [model]="selectedcomponent.button.disabled"
            (onChange)="onSelectedCompChange('button', 'disabled', $event)"></wms-toggle>
            <div class="property-value bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent.button?.disabled?.toString().indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable"
                    value="{{liveWidgetSettingsService.selectedComponent.button.disabled}}" [readonly]="true"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.button.disabled"
                    title="{{liveWidgetSettingsService.selectedComponent.button.disabled}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.button, 'disabled')"></button>
            </div>
            <button name="wm-bind-property-disabled"
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'disabled', 'button')"
                class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISABLED}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.selectedComponent.button?.hasOwnProperty('shortcutkey')">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SHORTCUTKEY}}</label>
            <label class="app-label">[{{locale.LABEL_KEYCODE}}] + </label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.shortcutkey"
                placeholder="{{locale.PLACEHOLDER_ENTER_SHORTCUT_KEY}}" data-identifier="property-shortcutkey"/>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SHORTCUTKEY}}"
                class="wms wms-help"></i>
            <p class="row help-block col-md-push-3 col-md-9">{{locale.HELP_MESSAGE_WIDGET_DESIGNER_SHORTCUTKEY}}</p>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_TABINDEX}}</label>
            <input type="number" class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.button.tabindex"
                placeholder="{{locale.PLACEHOLDER_BUTTON_TAB_INDEX}}" data-identifier="property-tabindex"/>
            <i tooltip-placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.MESSAGE_HELP_PROPERTY_TABINDEX}}" class="wms wms-help"></i>
        </div>
    </div>
    <div *ngIf="liveWidgetSettingsService.selectedComponent && liveWidgetSettingsService.componentDefnObject.isLayout" class="dialog-form-section">
        <h4>{{locale.LABEL_PROPERTY_ROW_ACTIONS}}</h4>
        <!--Title-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displayName"
                *ngIf="liveWidgetSettingsService.selectedComponent?.field?.displayName?.indexOf('bind:') !== 0"
                placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_TITLE}}" data-identifier="property-title" />
            <div class="bind-input-wrapper"
                *ngIf="liveWidgetSettingsService.selectedComponent?.field?.displayName?.indexOf('bind:') === 0">
                <input type="text"
                    class="form-control app-textbox bound-value bound-value-disable" disabled
                    value="{{liveWidgetSettingsService.selectedComponent.field.displayName}}"
                    wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.displayName"
                    title="{{liveWidgetSettingsService.selectedComponent.field.displayName}}" />
                <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent?.field, 'displayName')"></button>
            </div>
            <button
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent ,'displayName', 'field')"
                [disabled]="liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.disabled"
                class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TITLE}}"
                class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_ROWACTIONSPOSITION}}</label>
            <select class="form-control app-select"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.rowactionsposition" data-identifier="property-position">
                <option *ngFor="let optVal of rowactionspositions; index as $index"  [value]="optVal.value" [selected]="liveWidgetSettingsService.selectedComponent.field.rowactionsposition == optVal.value"
                    (change)="liveWidgetSettingsService.selectedComponent.field.rowactionsposition = optVal.value">
                    {{optVal.label || optVal}}
                </option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.MESSAGE_HELP_PROPERTY_ROWACTIONSPOSITION}}" class="wms wms-help"></i>
        </div>
        <!--Width-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDTH}}</label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widthValue"
                placeholder="{{liveWidgetSettingsService.designerType === 'TABLE' ? locale.PLACEHOLDER_DESIGNER_COLUMN_WIDTH : locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDTH}}" data-identifer="property-width"/>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_WIDTH}}"
                class="wms wms-help"></i>
        </div>
        <!--width unit-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDTH_UNIT}}</label>
            <select class="form-control app-select"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widthUnit" data-identifer="property-widthunit">
                <option *ngFor="let opt of liveWidgetSettingsService.unitOptions">{{opt}}</option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true"
                tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDTH_UNIT}}" class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_CLASS}}</label>
            <input class="form-control app-textbox"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.class"
                placeholder="{{liveWidgetSettingsService.designerType === 'TABLE' ? locale.PLACEHOLDER_DESIGNER_COLUMN_CLASS : locale.HELP_MESSAGE_WIDGET_DESIGNER_CLASS}}" data-identifer="property-class" />
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_CLASS}}"
                class="wms wms-help"></i>
        </div>
    </div>
</div>
